import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import Logo from "@/components/Logo";

const links = [
  { to: "/how-it-works", label: "Fares" },
  { to: "/bearing", label: "The Bearing" },
  { to: "/about", label: "Operator" },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {}, [pathname]);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 bg-paper transition-all duration-300 ${scrolled ? "nav-shadow" : ""}`}
    >
      {/* Desktop */}
      <div className="hidden md:flex max-w-[1280px] mx-auto px-6 lg:px-10 h-[72px] items-center justify-between relative">
        <Logo size="md" />

        <nav className="flex items-center gap-10 absolute left-1/2 -translate-x-1/2">
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
              className={({ isActive }) =>
                `text-sm transition-colors ${isActive ? "text-ink" : "text-ink-muted hover:text-ink"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/contact" data-testid="nav-cta-button" className="btn-primary">
          Request a Bearing
        </Link>
      </div>

      {/* Mobile */}
      <div className="md:hidden">
        <div className="max-w-[1280px] mx-auto px-5 pt-3 pb-2 flex items-center justify-between">
          <Logo size="sm" />
          <Link
            to="/contact"
            data-testid="nav-cta-button-mobile"
            className="btn-primary"
            style={{ padding: "10px 14px", fontSize: "12px" }}
          >
            Request
          </Link>
        </div>
        <nav
          data-testid="mobile-nav-row"
          className="flex items-center gap-5 px-5 pb-3 overflow-x-auto whitespace-nowrap"
        >
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s/g, '-')}`}
              className={({ isActive }) =>
                `text-[12px] tracking-wide transition-colors ${isActive ? "text-ink" : "text-ink-muted hover:text-ink"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
      </div>
    </header>
  );
}
